module.exports = __webpack_public_path__ + "static/media/angus-roast-beef.d6cbe396.jpg";